import { BaseCamelCasedResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
export class WholesaleLimitDetailResource extends BaseCamelCasedResource {
    pk() {
        return `${this.applicationNumber}`;
    }
}
WholesaleLimitDetailResource.urlRoot = apiResourceUrl("wholesaleLimit/{vendorId}/detail");
//# sourceMappingURL=WholesaleLimitDetailResource.js.map